 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"home":"home","explain":"explain","feedback":"feedback","switch":"switch","transfer":"transfer"}[chunkId]||chunkId) + "." + {"chunk-023b2903":"a37ebe41","chunk-103df2a1":"a6168e7b","chunk-155cc76d":"4283e8c9","chunk-24570e6f":"aa41e796","chunk-282dc4f3":"aa9eacfe","chunk-282dddb7":"de7d4997","chunk-2b318400":"6c1a57eb","chunk-2d44f521":"712b94fa","chunk-2f6dc55f":"7ae729ea","chunk-3f7104b2":"4371b6a1","chunk-3f9fda56":"855b5375","chunk-46c69f14":"cfbe6a43","chunk-47e46b82":"377d4ac0","chunk-505e405d":"3dbc2a7e","chunk-521dd0c4":"9c201425","chunk-58049e04":"26cafbcc","chunk-5a10cbaa":"50eb5911","chunk-5b3da5fe":"22a43904","chunk-5b58015d":"7663a373","chunk-5cc4816b":"8c63a13d","chunk-5fe79acd":"3c863308","chunk-61fce52c":"c6a8db53","chunk-6fac3796":"9977d016","chunk-7d7ca3c0":"557f0af7","chunk-7dc7271f":"449c063b","chunk-913fd0fa":"26c6b02b","chunk-bd589d8e":"d8d3c6af","chunk-6e714126":"3a9fc212","chunk-c88acd54":"b937f569","chunk-e982a3b8":"4d0afe57","chunk-02abb509":"59f357d7","chunk-2cec1c0d":"754bf274","chunk-3c7dacae":"59faf9dc","chunk-f7a3d0c2":"c245e1de","chunk-e58d57fc":"f88f00c3","home":"d77346f0","chunk-7535fe1e":"d640ab12","chunk-fd3d01a2":"202320f9","chunk-ff886034":"314b120a","explain":"6a8bbffb","feedback":"704d5388","switch":"19b24125","transfer":"b0ec6c6c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-023b2903":1,"chunk-103df2a1":1,"chunk-155cc76d":1,"chunk-24570e6f":1,"chunk-282dc4f3":1,"chunk-282dddb7":1,"chunk-2b318400":1,"chunk-2d44f521":1,"chunk-2f6dc55f":1,"chunk-3f7104b2":1,"chunk-3f9fda56":1,"chunk-46c69f14":1,"chunk-47e46b82":1,"chunk-505e405d":1,"chunk-521dd0c4":1,"chunk-58049e04":1,"chunk-5a10cbaa":1,"chunk-5b3da5fe":1,"chunk-5b58015d":1,"chunk-5cc4816b":1,"chunk-5fe79acd":1,"chunk-61fce52c":1,"chunk-6fac3796":1,"chunk-7d7ca3c0":1,"chunk-7dc7271f":1,"chunk-913fd0fa":1,"chunk-6e714126":1,"chunk-c88acd54":1,"chunk-02abb509":1,"chunk-2cec1c0d":1,"chunk-3c7dacae":1,"chunk-e58d57fc":1,"home":1,"chunk-7535fe1e":1,"chunk-fd3d01a2":1,"chunk-ff886034":1,"explain":1,"feedback":1,"switch":1,"transfer":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"home":"home","explain":"explain","feedback":"feedback","switch":"switch","transfer":"transfer"}[chunkId]||chunkId) + "." + {"chunk-023b2903":"d6488990","chunk-103df2a1":"094fb215","chunk-155cc76d":"96efcadd","chunk-24570e6f":"1d56aa9e","chunk-282dc4f3":"bff9e1a6","chunk-282dddb7":"211dee13","chunk-2b318400":"7c645c60","chunk-2d44f521":"0b6cb3cb","chunk-2f6dc55f":"f6b4e508","chunk-3f7104b2":"f768d481","chunk-3f9fda56":"7c9c45b3","chunk-46c69f14":"134cc3cf","chunk-47e46b82":"3a38b735","chunk-505e405d":"54f49260","chunk-521dd0c4":"21d6cbac","chunk-58049e04":"2b719411","chunk-5a10cbaa":"73fc1706","chunk-5b3da5fe":"b9dca1a8","chunk-5b58015d":"dfd36597","chunk-5cc4816b":"741e55fc","chunk-5fe79acd":"e2a9af75","chunk-61fce52c":"b514df08","chunk-6fac3796":"2253a219","chunk-7d7ca3c0":"dad3057a","chunk-7dc7271f":"61629221","chunk-913fd0fa":"89e293e6","chunk-bd589d8e":"31d6cfe0","chunk-6e714126":"0b66b1ad","chunk-c88acd54":"ad12b10d","chunk-e982a3b8":"31d6cfe0","chunk-02abb509":"d9f4b43b","chunk-2cec1c0d":"4d3aabe1","chunk-3c7dacae":"35794a03","chunk-f7a3d0c2":"31d6cfe0","chunk-e58d57fc":"a7b23f1f","home":"83c6ded2","chunk-7535fe1e":"d57539e9","chunk-fd3d01a2":"0cba65cc","chunk-ff886034":"2a2611ef","explain":"cea58b37","feedback":"f7fbabb6","switch":"2eab4e3d","transfer":"365b4224"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
